import { useWindowSize } from '@Components/Utilities/WindowSize';
import translator from '@Components/Utilities/Translator';
import HeaderLink from '@Components/Header/HeaderLink';
import HamburgerMenu from '@Components/Header/HamburgerMenu';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useRef, useState, useEffect } from 'react';
import { sandhillsRequest, getURLParameter, gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { LinkRelationTypes } from '@Components/Utilities/SandhillsConstants';
import { setLocalStorageValue } from '@Components/Utilities/CookieHelper';
import { LoginPromptEvents } from '@Components/Utilities/SandhillsConstants';
import AppBanner from '@Components/Shared/AppBanner';
import AnimatedQuickFind from '@Components/Header/AnimatedQuickFind';
import SignInForBestExperienceModal from '@Components/Shared/Modals/SignInForBestExperienceModal';

const SiteSelector = loadable(() => import('@Components/Header/SiteSelector'));
const LoginPromptModal = loadable(() => import('@Components/Shared/Modals/LoginPromptModal'));
const Modal = loadable(() => import('@Components/Shared/Modals/Modal'));
const AppSwitcher = loadable(() => import('@Components/Header/AppSwitcher'));


const HeaderView = (props) => {

    const {
        loginPromptEventId,
        pageName,
        siteName,
        IsAuctionResults,
        showLoginPromptSiteSetting
    } = props;

    const setKeywordSearchState = useSetRecoilState(atoms.keywordSearchStateAtom);
    const routes = useRecoilValue(atoms.routes);
    const currentUser = useRecoilValue(atoms.currentUser);
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const windowSize = useWindowSize();
    const hasListingsInput = props.Links.filter(lnk => lnk.Key == 'lnkListingsInput' && lnk.ShowOnDesktop).length > 0;
    const listingInputLink = hasListingsInput && props.Links.filter(lnk => lnk.Key == 'lnkListingsInput' && lnk.ShowOnDesktop)[0];
    const featuredLinks = props.Links.filter(lnk => lnk.Key !== 'lnkListingsInput' && lnk.Groups.includes('BottomRowFeaturedLinks') && lnk.ShowOnDesktop);
    const [signInModal, setSignInModal] = useState(false);//This is shut off presently.  Talk with Brennan or Kevin for details.  TOID: 86477573
    const [isScrollable, setIsScrollable] = useState(false)
    const [scrolledLeft, setScrolledLeft] = useState(true);
    const [scrolledRight, setScrolledRight] = useState(false);
    const scrollRef = useRef();
    const [emailPhonePopupVisible, setEmailPhonePopupVisible] = useState(false);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    //only show loginPrompt if they are not logged in and it's not a hosted site and not a bot.
    const [showLoginPrompt, setShowLoginPrompt] = useState(showLoginPromptSiteSetting && !currentUser?.IsAuthenticated && !currentSite.Site.IsHostedSite && !currentUser.IsSearchEngine);
    const [modalQSVisible, setModalQSVisible] = useState(true);
    const [showAppSwitcher, setShowAppSwitcher] = useState(false);
    const [showMobileAccount, setShowMobileAccount] = useState(false);
    const [currentPage, setCurrentPage] = useState('');
    const [expandCategories, setExpandCategories] = useState(false);


    useEffect(() => {
        if (currentSite.Site.IsBidcaller) {
            showVerificationPopup();
        }
        checkForQSModalParam();
        setCurrentPage(window.location.href);

        setKeywordSearchState(prev => ({
            ...prev,
            AutocompleteTerms: props.AutocompleteTerms,
            QuickFindPlaceholder: props.QuickFindPlaceholder,
            QuickFindActionURL: props.QuickFindActionURL,
            QuickFindSearchTypes: props.QuickFindSearchTypes,
            PartsSearchURL: props.PartsSearchURL,
            AttachmentsSearchURL: props.AttachmentsSearchURL
        }));

    }, []);

    useEffect(() => {
        scrollingArrows();
    }, [scrollRef.current]);




    const scrollingArrows = () => {
        const element = scrollRef.current;

        if (element) {
            setIsScrollable(element.scrollWidth > element.clientWidth);

            if (element.scrollLeft === 0) {
                //Scrolled all the way left
                setScrolledLeft(true);
                setScrolledRight(false);
            }
            else if (element.scrollLeft + element.clientWidth === element.scrollWidth) {
                //Scrolled all the way right
                setScrolledRight(true);
                setScrolledLeft(false);
            } else {
                //Scroll is in the middle
                setScrolledLeft(false);
                setScrolledRight(false);
            }
        }
    }

    const showVerificationPopup = () => {
        sandhillsRequest({
            url: routes.ValidateEmailPhone,
            method: 'POST',
            errorHandling: {
                message: 'An error occurred while obtaining verification dates',
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        }).then((response) => {
            if (response) {
                setEmail(response.Email);
                setPhone(response.Phone);
                setEmailPhonePopupVisible(true);
            }
        });
    }
    const toggleCategories = () => {
        setExpandCategories(!expandCategories);
        gtmPushEvent('cat-header-' + (expandCategories ? 'collapse' : 'expand'));
    }
    const toTitleCase = (str) => {
        return str.replace(
            /\w\S*/g,
            text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
        );
    }

    const closeVerificationPopup = () => {
        setEmailPhonePopupVisible(false);
    }

    const verificationPopupUpdateInfo = () => {
        sandhillsRequest({
            url: routes.UpdateEmailPhoneVerification,
            method: 'POST',
            errorHandling: {
                message: 'An error occurred while obtaining verification dates',
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        })
    }

    const confirmPopup = () => {
        closeVerificationPopup();
        verificationPopupUpdateInfo();
    }

    const closeLoginPrompt = () => {
        setLocalStorageValue(LoginPromptEvents.loginPromptLastClosed.Text, new Date());
        setShowLoginPrompt(false);
    };

    const checkForQSModalParam = () => {
        if (getURLParameter(window.location.href, "sam") || getURLParameter(window.location.href, "samw") || getURLParameter(window.location.href, "mao") || getURLParameter(window.location.href, "tsu")) {
            setModalQSVisible(true);
            return;
        }
        setModalQSVisible(false);
    };

    const emailPhonePopup = () => {
        return (
            <Modal containerClassName='verification-modal-content' onEscapeKeyClose={closeVerificationPopup}>
                <Modal.Header onClose={closeVerificationPopup}>
                    <Modal.Title>
                        {translator.translate('sandhills.emailphoneverification')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <hr />
                    <p className='top-explanation'>{translator.translate("sandhills.pleaseverifybelowvalues")}:</p>
                    <div className='email-phone-values'>
                        <div className='email'>
                            <label>{translator.translate("email")}</label>
                            <input className='email-input' type='text' value={email} readOnly />
                        </div>
                        <div></div>
                        <div className='phone'>
                            <label>{translator.translate("sandhills.Phone")}</label>
                            <input className='phone-input' type='text' value={phone} readOnly />
                        </div>
                    </div>
                    <div className='bottom-buttons'>
                        <a className='update-button' href={props.Links[3].SubMenu.Links[2].Url}>{translator.translate("sandhills.update")}</a>
                        <button className='ts-button confirm-button' onClick={confirmPopup}>{translator.translate("sandhills.confirm")}</button>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }

    return (
        <>
            {emailPhonePopupVisible && emailPhonePopup()}
            {props.LocalhostSites && <SiteSelector {...props} />}
            <header className='site-header no-print'>
                {(showLoginPrompt && !modalQSVisible) && <LoginPromptModal onClose={closeLoginPrompt} loginPromptEventId={loginPromptEventId} pageName={pageName} siteName={siteName} IsAuctionResults={IsAuctionResults} isMobile={windowSize.isMobile} />}
                {!currentSite?.IsMobileAppContext &&
                    <div className="header-content-wrapper" style={{ position: 'relative', zIndex: 1300 }}>
                        {props.AppDownloadLink && windowSize.isMobile &&
                            <div className='app-banner' style={{ zIndex: signInModal ? 1504 : 'unset', position: 'relative' }}>
                                <AppBanner AppDownloadLink={props.AppDownloadLink} AppLogo={props.AppLogo} IsAppleDevice={props.IsAppleDevice} />
                            </div>
                        }
                        <div className='top-row'>
                            <nav className='top-row-content' style={{ zIndex: signInModal ? 1504 : 'unset' }}>
                                <div className='auth-container mobile-hide'>
                                    <div className={currentUser.IsAuthenticated ? 'logged-in' : 'logged-out'}>
                                        {currentSite.Site.IsAuctionTime ?
                                            <ul className='account-dropdown'>
                                                {props.Links.filter(lnk => lnk.Groups.includes('AuthLinks') && lnk.ShowOnDesktop).map(lnk =>
                                                    <li key={lnk.Key}>
                                                        <HeaderLink {...lnk} />
                                                    </li>
                                                )}
                                            </ul>
                                            :
                                            <>
                                                {props.Links.filter(lnk => lnk.Groups.includes('AuthLinks') && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                            </>
                                        }

                                        {currentSite.Site.IsAuctionTime &&
                                            <>
                                                {props.Links.filter(lnk => lnk.Groups.includes('WatchlistLinks') && lnk.ShowOnDesktop).map(lnk =>
                                                    <a href={routes.WatchList} className="watchlist-dropdown-link">
                                                        <ul className="watchlist-dropdown">
                                                            <li key={lnk.Key}>
                                                                <HeaderLink {...lnk} />
                                                            </li>
                                                        </ul>
                                                    </a>
                                                )}
                                                {props.Links.filter(lnk => lnk.Key == 'lnkMyBids').map(lnk =>
                                                    <a href={routes.WatchList_MyBids} className="watchlist-dropdown-link">
                                                        <ul className="watchlist-dropdown">
                                                            <li key={lnk.Key}>
                                                                <HeaderLink {...lnk} />
                                                            </li>
                                                        </ul>
                                                    </a>
                                                )}
                                            </>
                                        }

                                        {!currentSite.Site.IsAuctionTime &&
                                            <>
                                            {props.Links.filter(lnk => lnk.Key == 'lnkMyBids').map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                            </>
                                        }

                                        {props.Links.filter(lnk => lnk.Key == 'btnAppSwitcher').map(lnk =>
                                            <div role="button"
                                                id='btnAppSwitcher'
                                                tabIndex="0"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        setShowAppSwitcher(!showAppSwitcher);
                                                    }
                                                }}
                                                className={"header-submenu__link " + (lnk.ClassName ? lnk.ClassName : '')}
                                                aria-label={(lnk.AriaLabel ? props.AriaLabel : lnk.Text)}
                                                onClick={() => setShowAppSwitcher(!showAppSwitcher)}>
                                                {lnk.Icon &&
                                                    <>
                                                        {lnk.IconIsImage ? <img src={lnk.Icon} alt="" /> : <i className={`fas ${lnk.Icon}`} />}
                                                        &nbsp;
                                                    </>}
                                                {lnk.Text}
                                            </div>)}
                                        {showAppSwitcher && !windowSize.isMobile && <AppSwitcher onClose={() => setShowAppSwitcher(false)} setShowAppSwitcher={setShowAppSwitcher} />}
                                    </div>
                                </div>
                                <div className='additional-header-links'>
                                    {props.Links.filter(lnk => lnk.Key == 'lnkQuoteMessageAlert' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} QuoteMessageAlert={props.QuoteMessageAlert} />)}
                                    {props.Links.filter(lnk => lnk.Key == 'lnkWebsiteHosting' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    {props.Links.filter(lnk => lnk.Key == 'lnkAdvertising' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    {props.Links.filter(lnk => lnk.Key == 'lnkAdvertisingPhone' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    {props.Links.filter(lnk => lnk.Key == 'lnkContactUs' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    {currentSite.Site.IsAuctionTime ?
                                        <ul className='lang-dropdown'>
                                            {props.Links.filter(lnk => lnk.Key == 'lnkLangSelector' && lnk.ShowOnDesktop).map(lnk =>
                                                <li key={lnk.Key}>
                                                    <HeaderLink isLangSelector={true} {...lnk} />
                                                </li>
                                            )}
                                        </ul>
                                        :
                                        <>
                                            {props.Links.filter(lnk => lnk.Key == 'lnkLangSelector' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                        </>
                                    }
                                    {props.Links.filter(lnk => lnk.Key == 'lnkMBKCanada' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    {props.Links.filter(lnk => lnk.Key == 'lnkGlobalBrands' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}

                                </div>
                                {signInModal && !windowSize.isMobile &&
                                    <div className='sign-in-container'>
                                        <SignInForBestExperienceModal
                                            onClose={(e) => { setSignInModal(false); }}
                                            links={props.Links}
                                        />
                                    </div>
                                }
                            </nav>
                        </div>
                        {windowSize.isMobile && <div className='mobile-top'>
                            <>
                                <span className='left-section'>
                                    <button className='login-btn' aria-label={translator.translate('sandhills.account')}>
                                        {currentUser.IsAuthenticated ? <span onClick={() => { setShowMobileAccount(!showMobileAccount) }}>{currentUser.FullName} <i className='fas fa-caret-down' /></span> :
                                            <>
                                                {props.Links.filter(lnk => lnk.Groups.includes('AuthLinks') && lnk.ShowOnDesktop && lnk.Text != 'Register').map(lnk => <> <HeaderLink key={lnk.Key} {...lnk} /> {lnk.ClassName.includes('login-link') && !(lnk.ClassName.includes('dealer-login') && props.Links.filter(x => x.Url.includes('vip')).length == 0) ? '/' : ''}</>)}
                                            </>
                                        }
                                    </button>
                                    {props.Links.filter(lnk => lnk.Key == 'lnkQuoteMessageAlert' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} QuoteMessageAlert={props.QuoteMessageAlert} />)}
                                </span>
                                {props.Links.filter(lnk => lnk.Key == 'btnAppSwitcher').map(lnk =>
                                    <div role="button"
                                        id='btnAppSwitcher'
                                        tabIndex="0"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                setShowAppSwitcher(!showAppSwitcher);
                                            }
                                        }}
                                        className={"header-submenu__link " + (lnk.ClassName ? lnk.ClassName : '')}
                                        aria-label={(lnk.AriaLabel ? props.AriaLabel : lnk.Text)}
                                        onClick={() => setShowAppSwitcher(!showAppSwitcher)}>
                                        {lnk.Icon &&
                                            <>
                                                {lnk.IconIsImage ? <img src={lnk.Icon} alt="" /> : <i className={`fas ${lnk.Icon}`} />}
                                                &nbsp;
                                            </>}
                                        {lnk.Text}
                                    </div>)}
                                {!currentUser.IsAuthenticated && !props.IsForGlobalMapHomePage && <div className='reg-area'><a href={routes.Register + '?to=' + encodeURIComponent(currentPage)} style={{ fontSize: '14px' }} rel={LinkRelationTypes.noFollow}>{translator.translate('sandhills.tradepubwebsite.mvc.register')}</a></div>}
                                {showAppSwitcher && windowSize.isMobile && <AppSwitcher onClose={() => setShowAppSwitcher(false)} setShowAppSwitcher={setShowAppSwitcher} />}
                            </>
                        </div>}
                        <div className='middle-row' style={{ zIndex: (signInModal && windowSize.isMobile && !currentSite.IsMobileAppContext) ? 1504 : 100, position: currentSite.Site.IsAuctionTime ? 'unset' : 'absolute', left: '0', width: '100%' }}>
                            <div className='middle-row-content'>
                                <div className='logo'>
                                    <a href={props.HomeUrl} className='main-logo-link'>
                                        <img className='main-logo' alt={props.LogoImageAltText} src={props.LogoUrl} />
                                    </a>
                                </div>
                                {windowSize.isMobile && <HamburgerMenu {...props} skipAccount={true} showMobileAccount={showMobileAccount} />}
                                {!windowSize.isMobile && !props.IsForGlobalMapHomePage &&
                                    <AnimatedQuickFind container={'.middle-row'} />
                                }
                            </div>
                            {signInModal && windowSize.isMobile && !currentSite.IsMobileAppContext &&
                                <div className='sign-in-container'>
                                    <SignInForBestExperienceModal
                                        onClose={(e) => { setSignInModal(false); }}
                                        links={props.Links}
                                    />
                                </div>
                            }
                            {windowSize.isMobile && (currentSite.Site.IsAuctionTime || currentSite.Site.IsBidcaller) &&
                                <div className='quickfind-container'>
                                    <AnimatedQuickFind container={'.quickfind-container'} />
                                </div>
                            }
                        </div>

                    </div>
                }

                {windowSize.isMobile && (currentSite.Site.IsAuctionTime || currentSite.Site.IsBidcaller) && currentSite.IsMobileAppContext &&
                    <div className='middle-row' style={{ marginTop: '15px' }}>
                        <div className='quickfind-container'>
                            <AnimatedQuickFind container={'.quickfind-container'} />
                        </div>
                    </div>
                }

                {windowSize.isMobile && featuredLinks.length > 0 &&
                    <div className='bottom-row' style={currentSite.Site.IsBidcaller && currentSite.IsMobileAppContext ? { marginTop: '0' } : {}}>
                        <div className='bottom-row-content'>
                            <div className='bottom-row-featured-links' onScroll={scrollingArrows} ref={scrollRef}>
                                {isScrollable && (currentSite?.Site?.IsBidcaller || currentSite.IsAuctionTimeAuctionSite) &&
                                    <>
                                        {!scrolledLeft ?
                                            <>
                                                <div className='left-header-arrow fade-in'>
                                                    <i className='fas fa-chevron-left' />
                                                </div>
                                                {scrolledRight ?
                                                    <div className='right-header-arrow fade-out'>
                                                        <i className='fas fa-chevron-right' />
                                                    </div> :
                                                    <div className='right-header-arrow'>
                                                        <i className='fas fa-chevron-right' />
                                                    </div>
                                                }
                                            </> :
                                            (!scrolledRight &&
                                                <>
                                                    <div className='right-header-arrow'>
                                                        <i className='fas fa-chevron-right' />
                                                    </div>

                                                    {scrolledLeft ?

                                                        <div className='left-header-arrow fade-out'>
                                                            <i className='fas fa-chevron-left' />
                                                        </div> :
                                                        <div className='left-header-arrow fade-in'>
                                                            <i className='fas fa-chevron-left' />
                                                        </div>
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                }
                                {featuredLinks.map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                            </div>
                        </div>
                    </div>
                }
                <div className='bottom-row' style={{ zIndex: (signInModal && currentSite.IsMobileAppContext) ? 1504 : 'unset', position: 'relative', marginTop: (currentSite.Site.IsAuctionTime || (currentSite.Site.IsBidcaller && windowSize.isMobile) || currentSite.IsMobileAppContext) ? '0' : windowSize.isMobile ? '65px' : '80px' }}>
                    <div className='bottom-row-content'>
                        <div className='bottom-row-buttons'>
                            {windowSize.isMobile && !props.IsForGlobalMapHomePage && !currentSite.Site.IsAuctionTime && !currentSite.Site.IsBidcaller &&
                                <div className='quickfind-container'>
                                    <AnimatedQuickFind container={'.quickfind-container'} />
                                </div>
                            }
                            <div className='bottom-row-buttons-row'>
                                {hasListingsInput &&
                                    <a id='sell-your-button' href={listingInputLink.Url} className='sell-btn' target='_blank' aria-label={listingInputLink.Text + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                                        {listingInputLink.Text}
                                        <i className='fas fa-chevron-right' />
                                        <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
                                    </a>}
                                {props.Links.filter(lnk => lnk.Key == 'lnkSerialNumberGuide' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                {props.Links.filter(lnk => lnk.Key == 'lnkShipWithFr8Star').map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                {props.Links.filter(lnk => lnk.Key == 'lnkGetFinance').map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                            </div>
                            {props.Links.filter(lnk => lnk.Key == 'lnkAdvertisingPhone' && lnk.ShowOnDesktop).map(lnk => {
                                var lnkCTA = Object.assign({}, lnk);
                                lnkCTA.Text = translator.translate('sandhills.tradepubwebsite.mvc.calltoadvertise') + ': ' + lnk.Text;
                                return <HeaderLink key={lnkCTA.Key + '_cta'} {...lnkCTA} ClassName={'call-btn'} />
                            })}
                        </div>
                        <>
                            <div className='bottom-row-links'>
                                {!windowSize.isMobile && props.MainCategories &&
                                    <span className='category-grouping'>
                                        <div onClick={(e) => { toggleCategories(); }} className='header-submenu__link category-menu' style={{ display: 'inline-block' }}>{translator.translate('sandhills.tradepubwebsite.mvc.categories')} <i className={expandCategories ? 'fas fa-caret-up' : 'fas fa-caret-down'} /></div>                                        
                                    </span>
                                }
                                {currentSite.Site.IsAuctionTime ?
                                    <ul className='category-dropdown'>
                                        {props.Links.filter(lnk => lnk.Key !== 'lnkListingsInput' && lnk.Groups.includes('BottomRowLinks') && lnk.ShowOnDesktop).map(lnk => (
                                            <li key={lnk.key}>
                                                <HeaderLink {...lnk} />
                                            </li>
                                        ))}
                                    </ul>
                                    :
                                    <>
                                        {props.Links.filter(lnk => lnk.Key !== 'lnkListingsInput' && lnk.Groups.includes('BottomRowLinks') && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    </>
                                }
                            </div>
                        </>
                    </div>
                    {signInModal && currentSite.IsMobileAppContext &&
                        <div className='sign-in-container'>
                            <SignInForBestExperienceModal
                                onClose={(e) => { setSignInModal(false); }}
                                links={props.Links}
                                mobileApp={currentSite.IsMobileAppContext}
                            />
                        </div>
                    }
                </div>
                {!windowSize.isMobile && props.MainCategories &&
                    <ul className={expandCategories ? 'category-list' : 'hidden'} >
                        <div className='flex-row'>
                            {props.MainCategories?.map((cat, index) => (
                                <li className='cat-link' onClick={() => gtmPushEvent('cat-header-link-click')}><a href={cat.sRouteURL}>{cat.Name}</a></li>
                            ))}
                        </div>
                    </ul>
                }
                {!windowSize.isMobile && featuredLinks.length > 0 &&
                    <div className='bottom-row'>
                        <div className='bottom-row-content'>
                            <div className='bottom-row-featured-links'>
                                {currentSite.Site.IsAuctionTime ?
                                    <ul className='category-dropdown'>
                                        {featuredLinks.map(lnk => (
                                            <li key={lnk.key}>
                                                <HeaderLink featured={true} {...lnk} />
                                            </li>
                                        ))}
                                    </ul>
                                    :
                                    <>
                                        {featuredLinks.map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                }
            </header>
        </>
    );
};

export default HeaderView;
global.HeaderView = HeaderView;